import { getCurrentInstance } from 'vue';
import { SprintState } from '@/types/sprint';
import { ResourceType } from '@/types/resources';

export default function useGetBookmarkTooltipText() {
  const _this = getCurrentInstance()?.proxy as any;
  if (!_this) return;

  const getTooltipText = (bookmarked: boolean, itemTitle: string, type: string, state: string) => {
    if (type === ResourceType.Sprint) {
      switch (state) {
        case SprintState.Active:
          return bookmarked
            ? _this.translate('unfavouriteCurrentSprint')
            : _this.translate('favouriteCurrentSprint');
        case SprintState.Planned:
          return bookmarked
            ? _this.translate('unfavouriteNextSprint')
            : _this.translate('favouriteNextSprint');
        default:
          return bookmarked
            ? _this.translate('unfavouriteSprintName', { sprintName: itemTitle })
            : _this.translate('favouriteSprintName', { sprintName: itemTitle });
      }
    }
    return bookmarked ? _this.translate('unfavourite') : _this.translate('favourite');
  };

  return {
    getTooltipText,
  };
}
